const initialState = {
  getListGroupPenilaian: [],
  getListJenisPenilaian: [],
  getListKriteriaPenilaian: [],
  getListParameterPenilaian: [],
  listDetailGrupPenilaian: [],
  showTabelJenisPenilaian: true,
  showTabelKriteriaPenilaian: true,
  showTabelParameterPenilaian: true,
  showTabelAllPenilaian: true,
};

const scoringReducer = (state = initialState, action) => {
  let { type, data } = action;
  switch (type) {
    case "SET_SHOW_JENIS_PENILAIAN":
      return {
        ...state,
        showTabelJenisPenilaian: data,
      };
    case "SET_SHOW_KRITERIA_PENILAIAN":
      return {
        ...state,
        showTabelKriteriaPenilaian: data,
      };
    case "SET_SHOW_PARAMETER_PENILAIAN":
      return {
        ...state,
        showTabelParameterPenilaian: data,
      };
    case "SET_SHOW_ALL_PENILAIAN":
      return {
        ...state,
        showTabelAllPenilaian: data,
      };
    case "SET_GET_ALL_GROUP_PENILAIAN":
      return {
        ...state,
        getListGroupPenilaian: data,
      };
    case "SET_GET_ALL_JENIS_PENILAIAN":
      return {
        ...state,
        getListJenisPenilaian: data,
      };
    case "SET_GET_ALL_KRITERIA_PENILAIAN":
      return {
        ...state,
        getListKriteriaPenilaian: data,
      };
    case "SET_GET_ALL_PARAMETER_PENILAIAN":
      return {
        ...state,
        getListParameterPenilaian: data,
      };
    case "SET_DETAIL_GRUP__PENILAIAN":
      return {
        ...state,
        listDetailGrupPenilaian: data,
      };
    default:
      return state;
  }
};
export default scoringReducer;
